import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BankAccountViewModel } from 'src/app/models/bankAccountViewModel';
import { BankService } from 'src/app/services/bank.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-modal-help-deposit',
  templateUrl: './modal-help-deposit.component.html',
  styleUrls: ['./modal-help-deposit.component.scss'],
})
export class ModalHelpDepositComponent implements OnInit {

  constructor(private modalCrtl: ModalController, private bankService: BankService) { }

  banks: BankAccountViewModel[] = [];
  bank: any = 0;
  coin: any;

  ngOnInit() {
    this.coin = Security.getCoin();
    this.bankService.getByCoinSystem(this.coin).subscribe(result => {
      if (result.success) {
        this.banks = result.data;
      }
    });
  }

  close() {
    this.modalCrtl.dismiss();
  }

  // changeAccount(vm){
  //   this.bank = vm;
  //   console.log(vm);
  // }

}
